<style scoped>
.chart-parameters {
  min-height: 500px;
}

.v-input {
  font-size: 10px;
}

.v-input__slot {
  margin-bottom: 0px;
}

.v-text-field {
  padding-top: 2px;
  margin-top: 1px;
}

.v-list__tile {
  font-size: 11px !important;
  height: 28px !important;
}

.v-label {
  font-size: 12px !important;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
  font-size: 12px;
  font-size: 12px !important;
}

.v-label {
  font-size: 12px !important;
  line-height: 1;
  min-height: 8px;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.bg-cover {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>

<template>
  <v-container grid-list-xs fluid ma-0 pa-0 class="bg">
    <v-layout row wrap ma-0 pa-0 class="bg">
      <div
        class="text-xs-center"
        xs12
        sm5
        md3
        style="width: 450px; height: auto; z-index: 20000"
      >
        <v-layout>
          <v-flex xs12>
            <v-card style="padding: 10px; padding-top: 10px" class="bg">
              <v-layout row wrap ma-0 pa-0>
                <v-flex xs12>
                  <v-layout row wrap ma-0 pa-0>
                    <template>
                      <v-expansion-panel ma-0 pa-0>
                        <v-expansion-panel-content
                          v-for="(group, i) in board.parameterGroups"
                          :key="i"
                        >
                          <template v-slot:header style="padding: 6px; 6px">
                            <div class="subheading">{{ group.name }}</div>
                          </template>
                          <v-layout row wrap ma-0 style="padding-left: 15px">
                            <v-flex
                              ma-0
                              pa-0
                              :class="parameter.class"
                              v-if="
                                (typeof parameter.groupId == 'undefined' &&
                                  group.id == 'default') ||
                                parameter.groupId == group.id
                              "
                              v-for="(parameter, key) in board.parameters"
                              :key="'parameter' + key"
                            >
                              <v-text-field
                                v-if="parameter.type == 'input'"
                                v-model="parameter.value"
                                :label="parameter.label"
                                v-on:blur="aChartChanged(parameter)"
                              ></v-text-field>
                              <v-textarea
                                v-if="parameter.type == 'textarea'"
                                v-model="parameter.value"
                                :label="parameter.label"
                                v-on:blur="aChartChanged(parameter)"
                              ></v-textarea>
                              <v-select
                                v-show="!parameter.wait"
                                v-if="parameter.type == 'select'"
                                :clearable="true"
                                :items="parameter.items"
                                :item-value="parameter.itemValue"
                                :item-text="parameter.itemText"
                                :label="parameter.label"
                                v-model="parameter.value"
                                v-on:change="aChartChanged(parameter)"
                              ></v-select>
                              <v-select
                                v-show="!parameter.wait"
                                v-if="parameter.type == 'multi-select'"
                                :items="parameter.items"
                                :item-value="parameter.itemValue"
                                :item-text="parameter.itemText"
                                :label="parameter.label"
                                v-model="parameter.value"
                                multiple
                                v-on:change="aChartChanged(parameter)"
                              ></v-select>
                              <v-slider
                                v-if="parameter.type == 'slider'"
                                :min="0"
                                :max="24"
                                v-model="parameter.value"
                                :label="parameter.label"
                                v-on:end="aChartChanged(parameter)"
                              ></v-slider>
                              <v-switch
                                v-if="parameter.type == 'switch'"
                                v-model="parameter.value"
                                :label="parameter.label"
                                v-on:change="aChartChanged(parameter)"
                              ></v-switch>
                              <v-textarea
                                v-if="parameter.type == 'code'"
                                v-model="parameter.value"
                                :label="parameter.label"
                                v-on:click="openDialog(parameter)"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </template>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-layout>
    <v-dialog v-model="dialog" :persistent="true" width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Code Editor
        </v-card-title>

        <v-card-text style="height: 700px">
          <ace-editor
            style="height: 100%"
            v-if="dialogParameter"
            v-model="code"
            @init="editorInit"
            :lang="lang"
            theme="chrome"
            width="100%"
            height="200"
          ></ace-editor>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="cancel()"> Cancel </v-btn>
          <v-btn color="primary" flat @click="save()"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

// has mapState, mapActions, mapGetters, mapMutations
const dataSourceNamespace = createNamespacedHelpers("dataSources");
const chartNamespace = createNamespacedHelpers("charts");

import VueAceEditor from "vue2-ace-editor";
import "brace/ext/language_tools";
import "brace/mode/sql";
import "brace/mode/html";
import "brace/mode/css";
import "brace/mode/javascript";
import "brace/mode/json";
import "brace/theme/chrome";

import { Photoshop, Swatches } from "vue-color";

function resolve(path, obj) {
  return path.split(".").reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self);
}

export default {
  props: ["grid", "mode"],
  data: function () {
    return {
      activeParameterGroupId: "default",
      colors: [],
      selectChart: false,
      chartType: null,
      fav: true,
      menu: false,
      message: false,
      hints: true,
      dialog: false,
      dialogParameter: null,
      editor: null,
      lang: 'sql',
    };
  },
  methods: {
    ...chartNamespace.mapMutations([
      "mToggleGridMenu",
      "mToggleEditable",
      "mSetType",
      "mSetActiveLayerType",
      "mSetLayerType",
      "mLoadActiveLayer",
      "mSetChartType",
      "mLoadParametersAndHydrator",
    ]),
    ...chartNamespace.mapActions(["aChartChanged"]),
    setChart(chart) {
      this.selectChart = false;
      this.mSetActiveLayerType(chart.id);
      this.mLoadParametersAndHydrator(this.activeLayer);
    },
    activateParameterGroupId: function (group) {
      this.activeParameterGroupId = group.id;
    },
    isParameterGroupActive: function (group) {
      if (
        this.activeParameterGroup &&
        this.activeParameterGroup.id == group.id
      ) {
        return true;
      }
      return false;
    },
    save() {
      this.dialog = false;
      this.dialogParameter.value = this.editor.getValue();
      // this.aChanged(this.dialogParameter);
    },
    cancel() {
      this.dialog = false;
    },
    editorInit: function (editor) {
          editor.setOptions({
            enableBasicAutocompletion: true
          });
          // beautify.beautify(editor.session);
          this.editor = editor;
          // this.code = this.dataSource.input;
          // this.mSetAceEditor(editor);
    },
    openDialog(parameter) {
      this.dialogParameter = parameter;
      this.code = parameter.value;
      this.dialog = true;
      if (typeof parameter.lang && parameter.lang) {
        this.lang = parameter.lang;
      } else {
        this.lang = "sql";
      }
    },
  },
  computed: {
    // ...dataSourceNamespace.mapState(['dataSources']),
    ...chartNamespace.mapState({
      board: (state) => state.chart,
      activeLayer: (state) => state.activeLayer,
      chartTypes: (state) => state.chartTypes,
      editable: (state) => state.editable,
    }),
  },
  components: {
    "swatches-picker": Swatches,
    "ace-editor": VueAceEditor,
  },
  mounted: function () {
    const _this = this;
    setTimeout(function () {
      // console.log("this.loadDataSources()");
      // console.log(_this.chart);
      //  _this.loadDataSources();
      // console.log("this.loadDefaults()");
      //  _this.loadDefaults();
      // console.log("_this.chart");
      // console.log(_this.chart);
    }, 1000);

    // console.log(this.chart);
  },
};
</script>
